import { HttpEvent, HttpEventType, HttpHeaderResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ComponentRef, Injectable } from '@angular/core';
import { AlertController, LoadingController, ToastController, PopoverController, ModalController } from '@ionic/angular';
import { splitInitCapitalCamelCase } from 'src/app/helpers/helper';
import { ApiResponse, ResponseStatus } from 'src/app/models/common.model';
import Swal from 'sweetalert2';


export type AlertTypes = "Alert" | "Toast" | "Combine";
export const AlertType: { [key: string]: AlertTypes } = { "Alert": "Alert", "Toast": "Toast", "Combine": "Combine" };

export type AlertColorType = 'danger' | 'dark' | 'warning' | 'light' | 'success' | 'primary' | 'secondary';
export const AlertColor: { [key: string]: AlertColorType } = { 'Danger': 'danger', 'Dark': 'dark', 'Warning': 'warning', 'Light': 'light', 'Success': 'success', 'primary': 'primary', 'secondary': 'secondary' };
export type AlertPositionType = 'bottom' | 'top' | 'middle';
export const AlertPosition: { [key: string]: AlertPositionType } = { 'Bottom': 'bottom', 'Top': 'top', 'Middle': 'middle' };
type OperationType = 'Delete' | 'Update' | 'Save' | 'Edit' | 'Add' | 'Create' | 'Load' | 'Fetch' | 'Process' | 'Submit' | 'Register' | 'Send' | 'Sent' | 'Upload' | 'Login' | 'Logout' | 'Void' | 'Parse' | 'Verify' | 'Approve' | 'DisApprove' | 'Reject' | 'Mark' | 'Download' | 'Generate' | 'Reset' | 'Change' | 'Activate' | 'Deactivate' | 'Archive' | 'Restore' | 'Merge';

@Injectable({
  providedIn: 'root'
})
export class AlertMsgProvider {

  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    public PopoverCtrl: PopoverController,
    private modalCtrl: ModalController
  ) { }


  async toaster(message: string, color: AlertColorType = AlertColor.Dark, position: AlertPositionType = AlertPosition.Bottom) {
    setTimeout(async () => {
      var top = await this.loadingCtrl.getTop();
      if (top) {
        this.loadingCtrl.dismiss();
      }
    }, 1200)

    const toast = await this.toastCtrl.create({
      message: message,
      color: color,
      duration: 2000,
      position: position
    });
    await toast.present();
  }

  async SuccessToaster(message: string, position: AlertPositionType = AlertPosition.Bottom) {
    await this.toaster(message, AlertColor.Success, position);
  }
  async ErrorToaster(message: string, position: AlertPositionType = AlertPosition.Bottom) {
    await this.toaster(message, AlertColor.Danger, position);
  }

  async alertMsg(title: string, message: string, response: any = null) {
    const alert = await this.alertCtrl.create({
      message: message,
      header: title,
      buttons: ['Ok']
    });
    await alert.present();
  }

  async SuccessAlert(title: string, subTitle: string, message: string, response: any = null) {
    setTimeout(async () => {
      var top = await this.loadingCtrl.getTop();
      if (top) {
        this.loadingCtrl.dismiss();
      }
    }, 1200)
    const alert = await this.alertCtrl.create({
      header: title,
      cssClass: 'alert-succ',
      subHeader: subTitle,
      message: message,
      buttons: ['Ok']
    });
    await alert.present();
  }

  async ErrorAlert(title: string, _subtitle: string, _message: string, response: any = {}) {
    let isApiError: boolean = false;
    if (response.error) {
      isApiError = true;
    }
    setTimeout(async () => {
      var top = await this.loadingCtrl.getTop();
      if (top) {
        this.loadingCtrl.dismiss();
      }
    }, 1200)
    let subTitle = _subtitle || "", message = _message || "";
    // if (response && response["status"] != "ValidationError" && response["status"] != "InvalidRequest" && response["status"] != "Exception") {
    //   var errors = response["errors"] || [];
    //   errors.forEach(error => {
    //     message = message + (error?.errorMessage ? "\n" + error?.errorMessage : '');
    //   });
    //   // return;
    // }

    subTitle = response["status"] || subTitle || "Error", message = message || response["message"] || "";
    message = message.replace('\n', '<br/>');
    const alert = await this.alertCtrl.create({
      header: title,
      subHeader: subTitle,
      message: message,
      cssClass: 'alert-err',
      buttons: ['Ok']
    });
    await alert.present();
  }



  async SweetSuccessAlert(title: string, message: string) {

    return Swal.fire({
      title: title,
      text: message,
      icon: 'success',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      heightAuto: false,
    });
  }


  async SweetErrorAlert(title: string, message: string) {

    return Swal.fire({
      title: title,
      text: message,
      icon: 'error',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      heightAuto: false,
    });

  }

  async SweetWarningAlert(title: string, message: string) {

    return Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      heightAuto: false
    });

  }


  async SweetInfoAlert(title: string, message: string) {

    return Swal.fire({
      title: title,
      text: message,
      icon: 'info',
      confirmButtonText: 'Ok',
      heightAuto: false
    });

  }

  async SweetQuestionAlert(title: string, message: string) {

    return Swal.fire({
      title: title,
      text: message,
      icon: 'question',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      heightAuto: false
    });
  }

  async SweetCustomAlert(options: any) {

    options.heightAuto = false;
    return Swal.fire(options);
  }

  async ResponseAlert(response: ApiResponse | HttpEvent<any> = null, recordType: string = "Record", operation: OperationType, alertType: AlertTypes = "Combine", successCallback: Function = (res: ApiResponse) => { }, errorCallback: Function = null, showSuccessMessage = true, showErrorMessage = true) {
    //return;
    var top = await this.loadingCtrl.getTop();
    if (response["type"] === HttpEventType.Sent) {
      if (top) top.message = "Uploading...";
      return;
      //progress.next(percentDone);
    }
    else if (response["type"] === HttpEventType.DownloadProgress) {
      // if (top) top.message = "Saving...";
      const percentDone = Math.ceil(100 * response["loaded"] / response["total"]);
      if (top) top.message = `Downloading ${percentDone}%...`;
      return;
      //progress.next(percentDone);
    }
    else if (response["type"] === HttpEventType.UploadProgress) {
      const percentDone = Math.ceil(100 * response["loaded"] / response["total"]);
      if (top) top.message = `Uploading ${percentDone}%...`;
      return;
      //progress.next(percentDone);
    } else if (response instanceof HttpHeaderResponse) {
      //progress.complete();
      //const datafiles = event.body.map(item => new Datafile(item));
      //callback(datafiles);
      if (top) top.message = "Receiving..."
      return;
    }
    else if (response["type"] === HttpEventType.Response) {
      //console.log("HttpHeaderResponse", response); 
      //progress.complete();
      //const datafiles = event.body.map(item => new Datafile(item));
      //callback(datafiles);
      if (top) top.message = "Completed..."
      return;
    }
    else {
      response = response['body'] || response;
    }


    if (response["status"] == ResponseStatus.Ok) {

      //setTimeout(async () => {
      var top = await this.loadingCtrl.getTop();
      if (top) {
        try {

          this.loadingCtrl.dismiss();
          (await this.loadingCtrl.getTop())?.message
        }
        catch (ex) {

        }
      }
      //}, 200)


      if (showSuccessMessage) {
        if (alertType == "Toast" || alertType == "Combine") {
          this.toaster(`${recordType} ${this.processedMessage(operation)} Successfully!`, "success", "bottom");
        }
        else {
          this.SuccessAlert("", `${this.processedMessage(operation)}`, `${recordType} ${this.processedMessage(operation)} Successfully!`);
        }
      }
      if (successCallback) successCallback(response);
    }
    else {
      this.ResponseErrorAlert(response, 'Combine', (er) => {
        errorCallback && errorCallback(response);
      }, showErrorMessage);
    }
  }

  private processedMessage(operation: OperationType) {
    switch (operation) {

      case "Add":
      case "Load":
      case "Process":
      case "Fetch":
      case "Edit":
      case "Register":
      case "Upload":
      case "Download":
      case "Mark":
      case "Reject":

        {
          return `${operation}ed`;
        }
      case "Update":
      case "Create":
      case "Delete":
      case "Save":
      case "Approve":
      case "DisApprove":

      case "Generate":
      case "Change":
      case "Activate":
      case "Deactivate":
      case "Archive":
      case "Restore":
      case "Merge":
      case "Parse":
        {
          return `${operation}d`;
        }
      case "Submit":
        {
          return "Submitted";
        }
      case "Login":
        {
          return "Logged In";
        }
      case "Logout":
        {
          return "Logged Out";
        }
      case "Void":
        {
          return "Voided";
        }
      case "Send":
        {
          return "Sent";
        }
      case "Verify":
        {
          return "Verified";
        }
      case "Reset":
        {
          return "Reset";
        }
      default: {
        return operation;
      }
    }

  }

  async ResponseErrorAlert(response: any = {}, alertType: AlertTypes = "Combine", errorCallback: Function | null = null, showErrorMessage = true) {
    let isApiError: boolean = false;
    if (response?.error) {
      isApiError = true;
    }
    setTimeout(async () => {
      var top = await this.loadingCtrl.getTop();
      if (top) {
        try {

          this.loadingCtrl.dismiss();
        }
        catch (ex) {

        }
      }
    }, 200)


    let subTitle = response["status"] == 400 ? "Validation Error" : response?.handledError?.message || "", message = response?.handledError?.description || response?.message || "", title = "";
    subTitle = subTitle || response["status"] || "Error", message = message || response["message"] || "";

    if (!message && response?.errors) {
      for (const error in response?.errors) {
        if (Object.prototype.hasOwnProperty.call(response?.errors, error)) {
          // const element = response?.errors[error];
          let erMessage = "";
          if ((error || "").indexOf("$.") >= 0) {
            erMessage = "Invalid input for field " + (error || "").replace("$.", "");
          }
          else if (Array.isArray(response?.errors[error]))
            response?.errors[error].forEach(element => {
              erMessage += (erMessage ? "\n" : "") + element;
            });
          else if (!Array.isArray(response?.errors[error]) && typeof (response?.errors[error]) == "object") {

            erMessage += (erMessage ? "\n" : "") + response?.errors[error].errorMessage;
          }
          message = message + (message ? "\n" : "") + erMessage;
        }
      }
    }

    if (errorCallback) {
      errorCallback(response);
    }
    if (showErrorMessage) {

      if (alertType == "Toast") {
        return this.toaster(`${subTitle} - \n${message}`, "danger", "top");
      }
      else {

        message = message.replace('\n', '<br/>');
        const alert = await this.alertCtrl.create({
          header: title,
          subHeader: subTitle,
          message: message,
          cssClass: 'alert-err',
          buttons: ['Ok']
        });
        return await alert.present();
      }
    }

  }

  ResponseErrorMessage(response: any = {}) {
    let isApiError: boolean = false;
    if (response?.error) {
      isApiError = true;
    }
    setTimeout(async () => {
      var top = await this.loadingCtrl.getTop();
      if (top) {
        try {

          this.loadingCtrl.dismiss();
        }
        catch (ex) {

        }
      }
    }, 200)


    let subTitle = response?.status == 400 ? "Validation Error" : '', message = response?.handledError?.description || "", title = "";


    subTitle = response?.handledError?.message || subTitle || response?.status || "", message = message || response?.message || "";

    if (!message && response?.errors) {
      for (const error in response?.errors) {
        if (Object.prototype.hasOwnProperty.call(response?.errors, error)) {
          // const element = response?.errors[error];
          let erMessage = "";
          if ((error || "").indexOf("$.") >= 0) {
            erMessage = "Invalid input for field " + (error || "").replace("$.", "");
          }
          else if (Array.isArray(response?.errors[error]))
            response?.errors[error].forEach(element => {
              erMessage += (erMessage ? "\n" : "") + element;
            });
          else if (!Array.isArray(response?.errors[error]) && typeof (response?.errors[error]) == "object") {

            erMessage += (erMessage ? "\n" : "") + response?.errors[error].errorMessage;
          }
          message = message + (message ? "\n" : "") + erMessage;
        }
      }
    }

    return { title, subTitle, message };
  }


  async alertWithSingleButton(header: string, message: string, buttontext: string, buttonHandler: (value: any) => boolean | void | { [key: string]: any; }) {
    const alert = await this.alertCtrl.create({
      header: header,
      message: message,
      buttons: [
        {
          text: buttontext,
          handler: buttonHandler
        }]
    });

    await alert.present();
    return alert.onDidDismiss();
  }

  async alertWithButton(header: string, message: string, buttontext: string, buttonHandler: (value: any) => boolean | void | { [key: string]: any; }) {
    const alert = await this.alertCtrl.create({
      header: header,
      message: message,
      buttons: [{
        text: 'Cancel',
      },
      {
        text: buttontext,
        handler: buttonHandler
      }]
    });

    await alert.present();
  }

  async loading(
    msg: string = "Please wait",
    duration: number = 0,
    spinner: "bubbles" | "circles" | "circular" | "crescent" | "dots" | "lines" | "lines-small" = 'bubbles') {
    const load = await this.loadingCtrl.create({
      message: msg,
      // duration: duration,
      spinner: spinner
    });
    await load.present();
    return load;
  }

  async dismissLoading(data?: any, role?: string, id?: string) {
    console.log("dismissLoading --");
    try {
      if (await this.loadingCtrl.getTop())
        this.loadingCtrl.dismiss(data, role, id);
    }
    catch (e: any) {

    }
  }
  async dismissPopover(data?: any, role?: string, id?: string) {
    try {
      if (await this.PopoverCtrl.getTop())
        this.PopoverCtrl.dismiss(data, role, id);
    }
    catch (e: any) {

    }
  }
  async dismissModal(data?: any, role?: string, id?: string) {
    try {
      if (await this.modalCtrl.getTop())
        this.modalCtrl.dismiss(data, role, id);
    }
    catch (e: any) {

    }
  }

  async showPopover(ev: any, component: any, data: any, cssClass = "") {
    const pop = await this.PopoverCtrl.create({
      component: component,
      event: ev,
      translucent: false,
      componentProps: data,
      cssClass: cssClass,
    });

    await pop.present();
    const res = await pop.onDidDismiss();
    return res;
  }

  async modal(component: any, data: any, cssClass = "") {
    const pop = await this.modalCtrl.create({
      component: component,
      componentProps: data,
      cssClass: cssClass,
    });

    await pop.present();
    const res = await pop.onDidDismiss();
    return res;
  }

  async Confirm(header: any, subHeader: any, message = '', isDanger = false, confirmText = "OK", cancelText = "Cancel") {
    const { role } = await this.ConfirmWithInput(header, subHeader, message, isDanger, [], confirmText, cancelText);
    return role;
  }

  async ConfirmWithInput(header: any, subHeader: any, message = '', isDanger = false, inputs = [], confirmText = "OK", cancelText = "Cancel") {
    const alert = await this.alertCtrl.create({
      header: header || 'Confirm',
      subHeader: subHeader,
      message: message,
      cssClass: isDanger ? 'alert-err' : '',
      inputs: inputs,
      buttons: [
        {
          text: cancelText,
          role: 'cancel',
          handler: () => { }
        },
        {
          text: confirmText,
          role: 'confirm',
          cssClass: isDanger ? 'alert-err' : '',
          handler: () => { }
        }
      ]
    });

    await alert.present();

    return await alert.onDidDismiss();

  }
  async ConfirmExit() {
    return (await this.Confirm('Confirm Exit', '', 'Do you want to exit?', false, 'Exit', 'Cancel')) == 'confirm';
  }
  async ConfirmUnSavedExit() {
    return (await this.Confirm('Unsaved Changes May Lose!', '', 'Do you want to continue?', true, 'Exit', 'Cancel')) == 'confirm';
  }

  async ConfirmDelete(recordName: string) {
    recordName = splitInitCapitalCamelCase(recordName || '');
    recordName = recordName.trim();
    return (await this.Confirm('Confirm Delete', '', `Do you want to delete "${recordName}"?`, true, "Delete")) == 'confirm';
  }

  async ConfirmRemove(recordName: string) {
    recordName = splitInitCapitalCamelCase(recordName || '');
    recordName = recordName.trim();
    return (await this.Confirm('Confirm Remove', '', `Do you want to remove "${recordName}"?`, true, "Remove")) == 'confirm';
  }

  async ConfirmEdit(recordName: string) {
    return (await this.Confirm('Modify' + (recordName ? ' "' + recordName + '"' : ''), '', 'Do you want to continue?', false)) == 'confirm';
  }

  async ConfirmMessage(message: any, isDanger = false, confirmText = "OK", cancelText = "Cancel") {
    return (await this.Confirm('', '', message, isDanger, confirmText, cancelText)) == 'confirm';

  }


}
